import React, { useState } from "react";
import { FieldError, useForm, UseFormRegister } from "react-hook-form";
import Select from "react-select";
import { customStyles } from "./CustomStyle";
import { useDispatch } from "react-redux";

export interface Option {
  role: string;
  role_id: number;
  branch_id: number;
  branch_name: string;
  company_name: string;
  gateway_name: string;
  panel_id: number;
  panel_name: string;
  name: string;
  id: string;
  apiUrl?: string;
}

interface DropDownField {
  id?: string;
  name?: string;
  options?: Option[];
  placeholder?: string;
  error?: FieldError;
  className?: string;
  register?: UseFormRegister<any>;
  errMsgClassName?: string;
  onChange?: (value: string) => void;
  onMenuClose?: (value: string) => void;
  onMenuOpen?: (value: string) => void;
  setValue?: (name: string, value: any) => void;
  readOnly?: boolean;
  style?: React.CSSProperties;
  onSelect?: (value: string) => void;
  defaultValue: string;
  size: string;
  multiple?: boolean;
  setSelectedCode: (value: string) => void;
  isDisabled ?: boolean;
}

const DropDownField: React.FC<DropDownField> = ({
  id,
  name,
  options,
  placeholder,
  error,
  className,
  register,
  errMsgClassName,
  onChange,
  setValue,
  readOnly,
  defaultValue,
  defaultCode,
  onSelect,
  multiple,
  size,
  apiUrl,
  setSelectedCode,
  onMenuClose,
  onMenuOpen,
  isDisabled
}) => {
  const registerData = register?.(name ?? "defaultName");
  const [selectedValues, setSelectedValues] = useState<number[]>([]);
  const dispatch = useDispatch();

  const allOption = { id: "0", name: "All" };
  const modifiedOptions = [allOption, ...options];

  const formatOptionLabel = ({ label, value }) => (
    <div className="flex items-center">
      <input
        type="checkbox"
        checked={selectedValues?.some((opt) => opt?.value === value)}
        readOnly
        className="w-4 h-4 mr-2 rounded border-gray-300"
      />
      {label}
    </div>
  );

  return (
    <div className={`${size}`}>
      {!multiple ? (
        <>
          <select
            disabled={readOnly ? readOnly : false}
            id={id}
            name={registerData?.name}
            defaultValue={setValue}
            onChange={(e) => {
              if (onChange) {
                onChange(e.target.value);
              } else if (onSelect) {
                onSelect(e.target.value);
              }

              registerData?.onChange(e);
            }}
            ref={registerData?.ref}
            className={`${
              error ? "has-error" : ""
            } ${"form-input border-slate-200 dark:border-zink-500"}    ${
              readOnly ? "bg-gray-200" : ""
            }  `}
          >
            <option value="" disabled>
              {placeholder}
            </option>

            {options?.length !== 0 ? (
              options?.map((option, i) => {
                return (
                  <option
                    key={i}
                    value={option?.id}
                    // name={calculateAge(option?.dob)}
                  >
                    {option?.label}
                  </option>
                );
              })
            ) : (
              <option value="" disabled>
                {placeholder}
              </option>
            )}
          </select>
          <div>
            {error && (
              <span
                className={
                  errMsgClassName
                    ? errMsgClassName
                    : "text-red-500 font-sm  text-[12px]"
                }
              >
                {error.message}
              </span>
            )}
          </div>
        </>
      ) : (
        <div>
          <Select
            closeMenuOnSelect={false}
            styles={customStyles}
            isMulti={multiple} // Enable multi-select
            options={options.map((opt: { id: number; name: string }) => ({
              value: opt?.id, // Use id as value
              label: opt?.name, // Use name as label
            }))}
            placeholder={placeholder}
            value={options
              .filter(
                (opt) =>
                  selectedValues?.includes(opt.id) ||
                  defaultCode?.includes(opt.id)
              )
              .map((opt) => ({ value: opt.id, label: opt.name }))}
            onChange={(selectedOptions) => {
              const isAllSelected = selectedOptions.some(
                (option) => option.value === "0"
              );

              let values;
              if (isAllSelected) {
                // Select all values except "All"
                values = options
                  ?.filter((opt) => opt.id !== "0")
                  .map((opt) => opt.id);
              } else {
                // Otherwise, store selected values
                values = selectedOptions.map((opt) => opt.value);
              }

              // Update state and dispatch
              setSelectedValues(values);
              if (setSelectedCode) dispatch(setSelectedCode(values));
              if (onChange) setValue?.(name, values);
            }}
            onMenuClose={() => {
              onMenuClose?.(name, selectedValues, apiUrl);
            }}
            onMenuOpen={() => {
              onMenuOpen?.(apiUrl);
            }}
            isDisabled={isDisabled}
          />
          {error && <p className="text-red-500 text-sm">{error.message}</p>}
        </div>
      )}
    </div>
  );
};

export default DropDownField;
